module.exports = __webpack_public_path__ + "static/img/AA-1.2e346ab4.png";